import React, { useEffect, useState } from "react";
import Formikform from "../../../../Components/ExtraComponents/Form/Formik_form1";
import { useFormik } from "formik";
import * as valid_err from "../../../../Utils/Common_Messages";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";

import {
  Email_regex,
  Mobile_regex,
  Name_regex,
} from "../../../../Utils/Common_regex";
import { useDispatch, useSelector } from "react-redux";
import Content from "../../../../Components/Dashboard/Content/Content";
import { GET_ALL_GROUP_SERVICES } from "../../../../ReduxStore/Slice/Admin/AdminSlice";
import { Get_All_SUBADMIN } from "../../../../ReduxStore/Slice/Subadmin/Subadminslice";
import { Get_All_Service_for_Client } from "../../../../ReduxStore/Slice/Common/commoSlice";
import { Get_Service_By_Group_Id } from "../../../../ReduxStore/Slice/Admin/GroupServiceSlice";
import {
  Add_User,
  GetLastCretedUserName,
} from "../../../../ReduxStore/Slice/Admin/userSlice";
import toast, { Toaster } from "react-hot-toast";
import ToastButton from "../../../../Components/ExtraComponents/Alert_Toast";
import "../../../../App.css";

const AddClient = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [selectedStrategies, setSelectedStrategies] = useState([]);

  const [first, setfirst] = useState([]);
  const [Addsubadmin, setAddsubadmin] = useState({ loading: true, data: [] });
  const [AllStrategy, setAllStrategy] = useState({ loading: true, data: [] });
  const [GetServices, setGetServices] = useState({ loading: true, data: [] });

  const permission = JSON.parse(localStorage.getItem("permission"));

  const [LastUSerName, setLastUSerName] = useState("");
  const [AllGroupServices, setAllGroupServices] = useState({
    loading: true,
    data: [],
  });

  const isValidEmail = (email) => {
    return Email_regex(email);
  };
  const isValidContact = (mobile) => {
    return Mobile_regex(mobile);
  };
  const isValidName = (mobile) => {
    return Name_regex(mobile);
  };
  const selector = useSelector((state) => state.DashboardSlice);

  useEffect(() => {
    let Service_Month_Arr = [];
    for (let index = 1; index < 2; index++) {
      Service_Month_Arr.push({
        month: index,
        endDate: `${index} Month Licence Expired On ${new Date(
          new Date().getFullYear(),
          new Date().getMonth() + index,
          new Date().getDate()
        )
            .toString()
            .split("00:00:00")[0]
          }`,
      });
    }
    setfirst(Service_Month_Arr);
  }, []);

  useEffect(() => {
    data();
    Get_Last_User_Name();
  }, []);

  const handleStrategyChange = (event) => {
    const strategyId = event.target.value;
    const strategyName = event.target.name;

    if (event.target.checked) {
      const newStrategies = [
        ...selectedStrategies,
        { id: strategyId, name: strategyName },
      ];
      setSelectedStrategies(newStrategies);
      formik.setFieldValue("Strategy", newStrategies);
    } else {
      const newStrategies = selectedStrategies.filter(
        (strategy) => strategy.id !== strategyId
      );
      setSelectedStrategies(newStrategies);
      formik.setFieldValue("Strategy", newStrategies);
    }

    // Mark strategy field as touched
    formik.setFieldTouched("Strategy", true);
  };

  const formik = useFormik({
    initialValues: {
      LastUsername: "",
      username: null,
      fullName: null,
      email: null,
      mobile: null,
      broker: null,
      licence: null,
      groupservice: null,
      parent_id: null,
      strategies: [],
      tomonth: "1",
      todate: null,
      fromDate: null,

      api_key: "null",
      api_secret: "",

      demat_userid: "null",
      parent_role: null,
      Strategy: false,
      multiple_strategy_select: false,
    },
    validate: (values) => {
      const errors = {};

      // Username validation
      if (!values.username) {
        errors.username = valid_err.USERNAME_ERROR;
      }

      // Full Name validation
      if (!values.fullName) {
        errors.fullName = valid_err.FULLNAME_ERROR;
      } else if (!isValidName(values.fullName)) {
        errors.fullName = valid_err.INVALID_ERROR;
      }

      // Mobile validation
      if (!values.mobile) {
        errors.mobile = valid_err.CONTACT_ERROR;
      } else if (!isValidContact(values.mobile)) {
        errors.mobile = valid_err.INVALID_CONTACT_ERROR;
      }

      // Email validation
      if (!values.email) {
        errors.email = valid_err.EMPTY_EMAIL_ERROR;
      } else if (!isValidEmail(values.email)) {
        errors.email = valid_err.INVALID_EMAIL_ERROR;
      }

      // Licence validation
      if (!values.licence) {
        errors.licence = valid_err.LICENCE_TYPE_ERROR;
      } else if (values.licence === "2" || values.licence === 2) {
        if (!values.broker) {
          errors.broker = valid_err.BROKER_ERROR;
        }
        if (!values.tomonth) {
          errors.tomonth = valid_err.LICENCE_ERROR;
        }
      } else if (
        (permission.Two_day_client == 1 && values.licence === "0") ||
        values.licence === 0
      ) {
        if (!values.broker) {
          errors.broker = valid_err.BROKER_ERROR;
        }
      } else if (values.licence === "1" || values.licence === 1) {
        if (!values.fromDate) {
          errors.fromDate = valid_err.FROMDATE_ERROR;
        }
        if (!values.todate) {
          errors.todate = valid_err.FROMDATE_ERROR;
        }
      }

      // Group service validation
      if (!values.groupservice) {
        errors.groupservice = valid_err.GROUPSELECT_ERROR;
      }

      return errors;
    },
    onSubmit: async (values) => {
      // Validation already handled by Formik, but double-check critical fields

      if (selectedStrategies.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Strategy Selected",
          text: "Please select at least one strategy before proceeding.",
          confirmButtonText: "OK",
        });
        return; // optional, prevents further code from running
      }

      const req = {
        FullName: values.fullName,
        UserName: values.username,
        Email: values.email,
        PhoneNo: values.mobile,
        licence: values.tomonth,
        license_type: values.licence,
        Strategies: selectedStrategies,
        fromdate: values.fromDate,
        todate: values.todate,
        broker: values.broker,
        parent_id:
          values.parent_id == null || values.parent_id === ""
            ? user_details.user_id
            : values.parent_id,
        parent_role:
          values.parent_id == null || values.parent_id === ""
            ? "ADMIN"
            : "SUBADMIN",
        api_secret: values.api_secret,
        api_key: values.api_key,
        group_service: values.groupservice,
        multiple_strategy_select:
          values.multiple_strategy_select === false ? "0" : "1",
      };

      const today = new Date();
      const after7Days = new Date();
      after7Days.setDate(today.getDate() + 7);

      const formatDate = (date) => {
        return date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
      };

      let result = await Swal.fire({
        title: "Confirm Client Details",
        width: "70%",
        html: `
  <div style="text-align:left; font-size: 14px; line-height: 1.6; display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;">
    
    <div><b>Username:</b> ${values.username}</div>
    <div><b>Full Name:</b> ${values.fullName}</div>
    <div><b>Email:</b> ${values.email}</div>

    <div><b>Phone:</b> ${values.mobile}</div>
    <div><b>Licence:</b> ${values.licence == 0
            ? "2 Days"
            : values.licence == 1
              ? "Demo"
              : values.licence == 2
                ? "Live"
                : "-"
          }</div>
    <div><b>Group Service:</b> ${AllGroupServices?.data.find((item) => values.groupservice === item._id)
            ?.name ?? "N/A"
          }</div>

    ${values.licence != 1
            ? `
        <div><b>Broker:</b> ${values.broker == "1"
              ? "CoinDcx"
              : values.broker == "2"
                ? "DeltaExchange"
                : values.broker == "3"
                  ? "Binance"
                  : values.broker == "4"
                    ? "Zebpay"
                    : values.broker == "5"
                      ? "Coin Switch"
                      : values.broker == "6"
                        ? "Pi42"
                        : "N/A"
            }</div>
        <div><b>API Key:</b> ${values.api_key || "-"}</div>
        <div><b>API Secret:</b> ${values.api_secret && values.api_secret !== "null"
              ? values.api_secret
              : "-"
            }</div>
      `
            : `<div style="grid-column: span 3;"><i>Broker & API details are hidden for Demo account.</i></div>`
          }

    <div><b>From Date:</b> ${values.licence == 0
            ? formatDate(today)
            : values.licence == 2
              ? formatDate(today)
              : values.fromDate ?? ""
          }</div>
    <div><b>To Date:</b> ${values.licence == 0
            ? formatDate(new Date(new Date().setDate(today.getDate() + 7)))
            : values.licence == 2
              ? formatDate(new Date(new Date().setMonth(today.getMonth() + 1)))
              : values.todate ?? ""
          }</div>

      <div style="grid-column: span 3;">
        <b>All Group Services:</b><br/>
        <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 5px;">
          ${GetServices?.data
            .map(
              (strategy) => `
                <span style="
                  display: inline-block;
                  border: 1px solid #ccc;
                  padding: 4px 10px;
                  border-radius: 20px;
                  font-size: 13px;
                ">
                  ${strategy.ServiceResult.name} [${strategy.categories?.category ?? "N/A"
                }]
                </span>`
            )
            .join("")}
        </div>
      </div>

    <div style="grid-column: span 3;">
      <b>Selected Strategies:</b><br/>
      ${selectedStrategies.length > 0
            ? `<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:5px;">
              ${selectedStrategies
              .map(
                (s) => `
                  <span style="
                    display:inline-block;
                    background-color:#f5f5f5;
                    border:1px solid #ccc;
                    padding:5px 10px;
                    border-radius:20px;
                    font-size:13px;
                  ">${s.name}</span>`
              )
              .join("")}
            </div>`
            : "<span style='color:red;'>No strategy selected</span>"
          }
    </div>

  </div>
  `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Add Client!",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        try {
          // ADD LOADER
          Swal.fire({
            title: "Updating...",
            html: "Please wait while we update the user.",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          const response = await dispatch(
            Add_User({ req, token: user_details.token })
          ).unwrap();

          Swal.close();

          if (response.status === 409) {
            toast.error(response?.data?.msg || "Conflict error");
          } else if (response.status) {
            toast.success(response.msg || "User added successfully");
            navigate("/admin/allclients");
          } else {
            toast.error(response.msg || "Unexpected error");
          }
        } catch (error) {
          toast.error(error?.msg || "Something went wrong");
        }
      }
    },
  });


  useEffect(() => {
    if (formik.values.broker === "1" || formik.values.broker === 1) {
      formik.setFieldValue("api_key", "null");
      formik.setFieldValue("api_type", "null");
      formik.setFieldValue("demat_userid", "null");
    }
    if (formik.values.broker === "2" || formik.values.broker === 2) {
      formik.setFieldValue("api_key", "null");
      formik.setFieldValue("app_key", "null");
      formik.setFieldValue("client_code", "null");
      formik.setFieldValue("api_type", "null");
    }
    if (formik.values.broker === "3" || formik.values.broker === 3) {
      formik.setFieldValue("api_key", "null");
      formik.setFieldValue("app_key", "null");
      formik.setFieldValue("client_code", "null");
      formik.setFieldValue("api_type", "null");
      formik.setFieldValue("demat_userid", "null");
    }
    if (formik.values.broker === "4" || formik.values.broker === 4) {
      formik.setFieldValue("api_secret", "null");
      formik.setFieldValue("app_id", "null");
      formik.setFieldValue("app_key", "null");
      formik.setFieldValue("api_type", "null");
      formik.setFieldValue("demat_userid", "null");
    }
    if (formik.values.broker === "5" || formik.values.broker === 5) {
      formik.setFieldValue("api_secret", "null");
      formik.setFieldValue("api_key", "null");
      formik.setFieldValue("app_key", "null");
      formik.setFieldValue("api_type", "null");
      formik.setFieldValue("demat_userid", "null");
    }
    if (formik.values.broker === "6" || formik.values.broker === 6) {
      formik.setFieldValue("api_secret", "null");
      formik.setFieldValue("api_key", "null");
      formik.setFieldValue("app_key", "null");
      formik.setFieldValue("api_type", "null");
      formik.setFieldValue("demat_userid", "null");
    }

    if (formik.values.licence === "2" || formik.values.licence === 2) {
      // ✅ LIVE
      formik.setFieldValue("tomonth", "1");
      formik.setFieldValue("fromDate", null);
      formik.setFieldValue("todate", null);
    }

    if (formik.values.licence === "1" || formik.values.licence === 1) {
      formik.setFieldValue("tomonth", null);
      formik.setFieldValue("broker", null);
    }
    if (formik.values.licence === "0" || formik.values.licence === 0) {
      formik.setFieldValue("fromDate", null);
      formik.setFieldValue("todate", null);
    }
  }, [formik.values.broker, formik.values.licence]);

  useEffect(() => {
    getGroupeServics();
  }, [formik.values.groupservice]);

  useEffect(() => {
    formik.setFieldValue(
      "username",
      (location.state !== null && location.state.UserName) || ""
    );
    formik.setFieldValue(
      "fullName",
      (location.state !== null && location.state.FullName) || ""
    );
    formik.setFieldValue(
      "email",
      (location.state !== null && location.state.Email) || ""
    );
    formik.setFieldValue(
      "mobile",
      (location.state !== null && location.state.PhoneNo) || ""
    );
  }, [location.state]);

  const Get_Last_User_Name = async () => {
    await dispatch(GetLastCretedUserName())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setLastUSerName(response.data.UserName);
          formik.setFieldValue("LastUsername", response.data.UserName);
        }
      })
      .catch((error) => {
        return;
      });
  };



  let fields = [
    {
      name: "LastUsername",
      label: "Last Username",
      type: "lastusername",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "username",
      label: "Username",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "fullName",
      label: "FullName",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "mobile",
      label: "Mobile",
      type: "number",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "licence",
      label: "License",
      type: "select",
      options: [
        permission.Two_day_client == 1 && { label: "2 Days", value: "0" },
        { label: "Demo", value: "1" },
        { label: "Live", value: "2" },
      ].filter(Boolean),
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "tomonth",
      label: "To Month",
      type: "select",
      options:
        first &&
        first.map((item) => ({ label: item.endDate, value: String(item.month) })),
      showWhen: (values) => values.licence === "2",
      label_size: 12,
      col_size: 4,
      disable: false,
      isSelected: true,
      madatory: true,
      
    },
    {
      name: "broker",
      label: "Broker",
      type: "select",
      options: permission?.broker_id?.map((item) => ({
        label: item.name,
        value: item.id,
      })),
      showWhen: (values) => values.licence === "2" || values.licence === "0",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "fromDate",
      label: "From Date",
      type: "datenew",
      showWhen: (values) => values.licence === "1",
      label_size: 12,
      col_size: 4,
      disable: true,
      madatory: true,
    },
    {
      name: "todate",
      label: "To Date",
      type: "datenew",
      showWhen: (values) => values.licence === "1",
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "api_key",
      label: "Api Key",
      type: "text",
      showWhen: (values) =>
        values.broker === "1" ||
        values.broker === "2" ||
        values.broker === "3" ||
        values.broker === "4" ||
        values.broker === "5" ||
        values.broker === "6",
      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "api_secret",
      label: "Api Secret",
      type: "text",
      showWhen: (values) =>
        values.broker === "1" ||
        values.broker === "2" ||
        values.broker === "3" ||
        values.broker === "4" ||
        values.broker === "5" ||
        values.broker === "6",

      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "parent_id",
      label: "Sub-Admin",
      type: "select",
      options:
        Addsubadmin.data &&
        Addsubadmin.data.map((item) => ({
          label: item.FullName,
          value: item._id,
        })),
      label_size: 12,
      col_size: 4,
      disable: false,
    },

    {
      name: "groupservice",
      label: "Group Service",
      type: "select",
      options:
        AllGroupServices.data &&
        AllGroupServices.data.map((item) => ({
          label: item.name,
          value: item._id,
        })),
      label_size: 12,
      col_size: 4,
      disable: false,
      madatory: true,
    },
    {
      name: "multiple_strategy_select",
      label: "Mutiple Selection Strategy",
      type: "checkbox",
      label_size: 12,
      col_size: 4,
      disable: false,
    },
  ];

  const getGroupeServics = async () => {
    if (formik.values.groupservice) {
      await dispatch(
        Get_Service_By_Group_Id({ _id: formik.values.groupservice })
      )
        .unwrap()
        .then((response) => {
          if (response.status) {
            setGetServices({
              loading: false,
              data: response.data,
            });
          }
        });
    }
  };

  const data = async () => {
    await dispatch(GET_ALL_GROUP_SERVICES())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllGroupServices({
            loading: false,
            data: response.data,
          });
        }
      });

    await dispatch(Get_All_SUBADMIN())
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAddsubadmin({
            loading: false,
            data: response.data,
          });
        }
      });

    await dispatch(
      Get_All_Service_for_Client({
        req: {},
        token: user_details.token,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setAllStrategy({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  if (selector && selector.permission) {
    if (
      selector.permission &&
      selector.permission.data &&
      selector.permission.data[0]
    ) {
      if (selector.permission.data[0].Two_day_client == 0) {
        fields = fields.map((field) => {
          if (field.name === "licence") {
            return {
              ...field,
              options: field.options.filter(
                (option) => option.label !== "2 Days"
              ),
            };
          }
          return field;
        });
      }
    }
  }

  useEffect(() => {
    if (formik.values.licence == 1) {
      formik.setFieldValue("fromDate", new Date().toISOString().split("T")[0]);
    } else {
      formik.setFieldValue("fromDate", null);
    }
  }, [formik.values.licence]);

  return (
    <>
      <Content
        Page_title="Add Client"
        button_title="Back"
        Page_title_showClient="Add and manage client profiles for seamless account onboarding"
        route="/admin/allclients"
      >
        <Formikform
          fieldtype={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Add Client"
          fromDate={formik.values.fromDate}
          toDate={formik.values.todate}
          LastUSerName={LastUSerName}
          additional_field={
            <>
              {GetServices?.data && GetServices?.data?.length > 0 && (
                <label className="mt-3">All Group Service</label>
              )}
              <div className="d-flex gap-2 flex-wrap my-3">
                {GetServices &&
                  GetServices?.data?.map((strategy) => (
                    <div key={strategy._id}>
                      <div
                        className="border border-secondary fw-normal px-2 py-1 rounded-pill"
                        style={{ fontSize: "0.65rem" }}
                      >
                        <span className="fw-bold" htmlFor={strategy.ServiceResult.name}>
                          {`${strategy.ServiceResult.name} `}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>

              {formik.touched.Strategy && formik.errors.Strategy && (
                <div style={{ color: "red" }} className="my-3">
                  {formik.errors.Strategy}
                </div>
              )}
              <hr />
              <label>
                All Strategy <span className="text-danger">*</span>
              </label>
              <div className="row">
                {AllStrategy.data.map((strategy) => {
                  const inputId = `strategy_${strategy._id}`;
                  return (
                    <div className="col-lg-2 col-4 mt-2" key={strategy._id}>
                      <div className="form-check custom-checkbox mb-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={inputId}
                          name={strategy.strategy_name}
                          value={strategy._id}
                          onChange={(e) => handleStrategyChange(e)}
                        />
                        <label
                          className="ms-1 form-check-label"
                          htmlFor={inputId}
                          style={{ cursor: "pointer" }}
                        >
                          {strategy.strategy_name}
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          }
        />

        <ToastButton />
      </Content>
    </>
  );
};
export default AddClient;
